export class Commissions{
    constructor(
        public groupId: Array<any> = Array<any>(),
        public terminalId: String = '',
        public ticketSalesCommission: String = '',
        public sportsBookNgr: String = '',
        public casinoNgr: String = '',
        public lotteryNgr: String = '',
        public saving: String = '',
        public mobileTerminalId: any = []
        ){}
} 